export default __webpack_public_path__ + "images/more.991bb1c2e9c5ea4453ec68e3dea57b03.svg";